export const CoinList = (currency) =>
  `https://api.coingecko.com/api/v3/coins/markets?vs_currency=${currency}&order=market_cap_desc&per_page=2&page=1&sparkline=false`;

export const SingleCoin = `https://api.coingecko.com/api/v3/coins/bitcoin`;
export const EthereumCoin = `https://api.coingecko.com/api/v3/coins/ethereum`;
